var React = require('react');

function NonEncryptedIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"opacity":"0.6"},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3.5 4C3.5 1.79086 5.29086 0 7.5 0H9.07143C11.5173 0 13.5 1.98274 13.5 4.42857V6C14.6046 6 15.5 6.89543 15.5 8V14C15.5 15.1046 14.6046 16 13.5 16H3.5C2.39543 16 1.5 15.1046 1.5 14V8C1.5 6.89543 2.39543 6 3.5 6H8.5H11.5V4.42857C11.5 3.08731 10.4127 2 9.07143 2H7.5C6.39543 2 5.5 2.89543 5.5 4H3.5ZM3.5 8H8.5H13.5V14H3.5V8ZM8.5 12C9.05229 12 9.5 11.5523 9.5 11C9.5 10.4477 9.05229 10 8.5 10C7.94772 10 7.5 10.4477 7.5 11C7.5 11.5523 7.94772 12 8.5 12Z","fill":"#E8EFFF"})));
}

NonEncryptedIcon.defaultProps = {"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none"};

module.exports = NonEncryptedIcon;

NonEncryptedIcon.default = NonEncryptedIcon;
